import React from "react"

const AdminDashboardPage = () => {
  const adminLinks = [
    { title: 'Ads', url: '/ads' },
    { title: 'Attendee Value Overrides', url: '/admin/attendee_value_overrides' },
    { title: 'AI Tuning', url: '/ai_tuning/1/edit' },
    { title: 'Boosts', url: '/boosts' },
    { title: 'Calendars', url: '/calendars' },
    { title: 'Companies', url: '/companies' },
    { title: 'Automated Emails', url: '/admin/automated_emails' },
    { title: 'Event Calendars', url: '/community_calendars' },
    { title: 'Event Reports', url: '/admin/event_reports?company_id=1' },
    { title: 'Imports', url: '/imports' },
    { title: 'Import Events', url: '/admin/import_events' },
    { title: 'Manual Event Rank', url: '/admin/manual_event_rank' },
    { title: 'Markets', url: '/markets' },
    { title: 'MCP Tokens (Claude Connector)', url: '/admin/mcp_tokens' },
    { title: 'Payments', url: '/payments' },
    { title: 'Press Releases', url: '/event_press_releases' },
    { title: 'Release Notes', url: '/admin/release_notes' },
    { title: 'Stripe Customer IDs', url: '/stripe_customer_ids' },
    { title: 'Attach Stripe Customer Manually', url: '/attach_stripe_customer_manually' },
    { title: 'Unverified Payments', url: '/unverified_payments' },
    { title: 'Subscriptions', url: '/subscriptions' },
    { title: 'Subscription Change Logs', url: '/subscription_change_logs' },
    { title: 'Users', url: '/users' },
  ];

  return (
    <div className="admin-dashboard">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center my-4">
              <h1 className="h2 text-dark fw-bold">Admin</h1>
            </div>

            <div className="card shadow-sm">
              <div className="card-header bg-primary text-white">
                <h5 className="card-title mb-0 text-white">
                  <span className="mr-2">
                    <i className="far fa-user text-white"></i>
                  </span>
                  Admin Only
                </h5>
              </div>
              <div className="card-body">
                <div className="row g-3">
                  {adminLinks.map((link, index) => (
                    <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3">
                      <a
                        href={link.url}
                        className="text-decoration-none"
                      >
                        <div
                          className="admin-link-card p-3 border rounded shadow-sm h-100 d-flex align-items-center justify-content-center text-center"
                          style={{
                            cursor: 'pointer',
                            transition: 'all 0.2s ease-in-out',
                            backgroundColor: '#f8f9fa'
                          }}
                        >
                          <div>
                            <i className="fa fa-external-link-alt text-primary mb-2" style={{ fontSize: '1.5rem' }}></i>
                            <h6 className="mb-0 text-dark fw-semibold">{link.title}</h6>
                          </div>
                        </div>
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboardPage;